import { types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";

/**
 * Base model for all ChatItem subtypes.
 */
export const BaseChatItem = types
  .model({
    id: types.identifier,
    timestamp: types.number,
    type: types.enumeration<ChatItemType>("ChatItemType", Object.values(ChatItemType))
  })
  .extend((self) => {
    const views = {
      /**
       * Should item be displayed in chat component?
       * Override in derived models.
       */
      get shown(): boolean {
        return true;
      }
    };
    const actions = {
      /**
       * Update chat item from room_message_updated event.
       * This is a no-op action, override it in specialised ChatItem models.
       * FIXME: ideally, this model should be API-agnostic
       *   ie. the event data should be consumed by handler and passed here as partial snapshot
       * @param {any} context update event payload
       */
      updateFromEvent(context: any) {
        return;
      }
    };
    return { views, actions };
  });
